export default __webpack_public_path__ + "static/media/reduce-waste-mobile.6692ad42.png";